import type { Situation } from '../partage/api/types';
import { jourLocal, joursEntre } from '../partage/datesEnMots';

/** La jauge d'une attente : la part de la piste, de 0 à 100. */
export interface MesureDeLAttente {
  part: number;
}

/**
 * **La jauge d'une attente** (chantier nettoyage-mots, ticket 03), sans rendu : la part de la
 * piste que `LigneAttente` dessine, de 0 à 100. Une longueur, jamais un nombre écrit.
 *
 * La piste va du jour où la demande est partie au jour attendu. Pendant l'attente **en cours**,
 * le repère est au bout et la part est le temps déjà passé, compté jusqu'à `aujourdhui`, le jour
 * de l'utilisateur (celui du serveur quand l'écran l'a, sinon `aujourdhui()` de `datesEnMots`).
 * Quand l'attente **dure trop** (`a_verifier`), la piste s'allonge derrière le repère de
 * `joursDAttente`, compté par le serveur au jour de l'utilisateur : l'écran ne le recompte pas.
 * Jamais le jour en temps universel, qui retardait d'un jour entre minuit et 2 h à Paris.
 */
export function mesurerLAttente(
  partieLe: string | null,
  situation: Pick<Situation, 'nom' | 'attenduLe' | 'joursDAttente'>,
  aujourdhui: string
): MesureDeLAttente | null {
  const attendueLe = situation.attenduLe;
  if (!partieLe || !attendueLe || !jourLocal(partieLe) || !jourLocal(attendueLe)) return null;

  const promis = joursEntre(partieLe, attendueLe);
  if (promis <= 0) return null;

  if (situation.nom !== 'a_verifier') {
    const passe = Math.min(Math.max(joursEntre(partieLe, aujourdhui), 0), promis);
    return { part: Math.round((passe / promis) * 100) };
  }
  const ecoule = promis + Math.max(situation.joursDAttente, 0);
  return { part: Math.round((promis / ecoule) * 100) };
}
